import { useState, useEffect, useRef } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from '../../shared/ConfirmModal';
import { Toast } from 'primereact/toast';
import { ToggleButton } from 'primereact/togglebutton';
import { getTeams, deleteTeam, teamLocations, teamLocationManage, teamUpdate } from '../../utils/urls';
import axios from '../../utils/axios';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { MultiSelect } from 'primereact/multiselect';
import AppModal from '../../shared/AppModal';
import FlexComponent from '../FlexComponent';

export default function TeamsTable() {
    const navigate = useNavigate()
    const toast = useRef(null);
    const [customers, setCustomers] = useState(null);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isMounted, setIsMounted] = useState(false)
    const [locationVisible, setLocationVisible] = useState(false);
    const [allowedLocations, setAllowedLocations] = useState(null);
    const [activeLocations, setActiveLocations] = useState(null);
    const [manageTeamId, setManageTeamId] = useState(null);

    const [submitLoading, setSubmitLoading] = useState(false)
    const [password360Visible, setPassword360Visible] = useState(false);
    const [emailPassword360Visible, setEmailPassword360Visible] = useState(false);
    const [email360, setEmail360] = useState('');
    const [password360, setPassword360] = useState('');
    const [ccEmail, setCcEmail] = useState('');
    const [selectedEmailPassword360User, setSelectedEmailPassword360User] = useState("");

    useEffect(() => {
        // setLoading(true);
        axios.get(getTeams, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setCustomers(response.data);
                    setLoading(false);
                }
            })
            .catch((error) => {
                setCustomers(null)

            })
    }, [getTeams, isMounted])

    const onGlobalFilterChange = (event) => {
        const value = event.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
    };

    const getSeverity = (value) => {
        switch (value) {
            case true:
                return 'success';

            case false:
                return 'danger';

            default:
                return null;
        }
    };

    const manageLocationView = (rowData) => {
        const team_id = rowData.team_id
        return <Button className='view-button' label="Manage" icon="pi pi-external-link" onClick={() => manageLocationDialog(team_id)} />
    };

    const manageLocationDialog = (team_id) => {
        const manageLocationUrl = `${teamLocations}${team_id}`

        axios.get(manageLocationUrl, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setActiveLocations(response.data.all_active_locations);
                    setAllowedLocations(response.data.allowed_locations);
                    setManageTeamId(team_id)
                    setLocationVisible(true)
                }
            })
            .catch((error) => {
                setActiveLocations(null)
                setAllowedLocations(null)
                setManageTeamId(null)
                setLocationVisible(false)

            })
    }

    const accept = (Data) => {
        axios.post(deleteTeam, Data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted);
                    toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            })
    }

    const reject = () => {
        console.log('closed')
    }

    const deleteBody = (rowData) => {
        const team_id = rowData.team_id
        return <Button icon="pi pi-trash" severity="danger" aria-label="Delete" onClick={() => handleDeleteLeader(team_id)} />;
    };

    const handleDeleteLeader = (team_id) => {
        const data = {
            team_id
        }

        confirmDialog({
            message: 'Are you sure you want to delete this Team?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => accept(data),
            reject
        });
    }


    const renderHeader = () => {
        const value = filters['global'] ? filters['global'].value : '';

        return (
            // <div className="flex justify-content-between table-header-container">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" value={value || ''} onChange={(e) => onGlobalFilterChange(e)} placeholder="Global Search" />
            </span>
            // <Button className='sync-button' label="Sync" icon="pi pi-sync" onClick={syncHandle} />
            // </div>
        );
    };

    const srNoBodyTemplate = (rowData, props) => {
        const rowIndex = props.rowIndex + 1;
        const db_outcome = rowData.outcome
        return <div className='status'>{rowIndex}</div>;
    };

    const handleLocationOnHide = () => {
        setActiveLocations(null)
        setAllowedLocations(null)
        setManageTeamId(null)
        setLocationVisible(false)
    }

    const handleEmailPassword360On = (rowData) => {
        setEmailPassword360Visible(true);
        setSelectedEmailPassword360User(rowData.team_id);
        setEmail360(rowData.office_360_email);
        setPassword360(rowData.office_360_password);
        setCcEmail(rowData.cc_email);
    };

    const handleEmailPassword360OnHide = () => {
        setEmailPassword360Visible(false);
        setSelectedEmailPassword360User(null);
        setCcEmail('');
        setEmail360('');
        setPassword360('');
        setPassword360Visible(false);
    };

    const update360EmailPassword = (rowData) => {
        const leader_id = rowData.id;
        return <Button className='view-button' label="Office 360/CC Email" icon="pi pi-user-edit" onClick={() => handleEmailPassword360On(rowData)} />;
    };

    const handlePassword360Visible = () => {
        setPassword360Visible(!password360Visible);
    };


    const handleLocationSubmit = () => {
        const data = {
            "team_id": manageTeamId,
            "allowed_locations": allowedLocations
        }
        axios.post(teamLocationManage, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setActiveLocations(null)
                    setAllowedLocations(null)
                    setManageTeamId(null)
                    setLocationVisible(false)
                    setIsMounted(!isMounted)
                    toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            })
    }

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleTeamUpdateSubmit = () => {
        // if (!email360?.trim()) {
        //     toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please enter the Email', life: 2000 });
        // } else {
        const isValid = isValidEmail(email360);
        const isValidCCEmail = isValidEmail(ccEmail)
        if (email360 && !isValid) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please Enter Valid Office 360 Email', life: 3000 });
        } else if (ccEmail && !isValidCCEmail) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please Enter Valid CC Email', life: 3000 });
        } else {
            const data = {
                office_360_email: email360,
                office_360_password: password360,
                cc_email: ccEmail,
            };
            setSubmitLoading(true)
            axios.post(`${teamUpdate}${selectedEmailPassword360User}`, data, {
                headers: { 'Content-Type': 'application/json' },
            })
                .then((response) => {
                    if (response.status === 200) {
                        setIsMounted(!isMounted);
                        setEmailPassword360Visible(false);
                        setSelectedEmailPassword360User(null);
                        setCcEmail('');
                        setEmail360('');
                        setPassword360('');
                        toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                    } else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    }
                    setSubmitLoading(false)
                })
                .catch(() => {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setSubmitLoading(false)
                });
        }
        // }
    };

    const locationManageFooter = (
        <div>
            <Button className='view-button' label="Submit" icon="pi pi-check" onClick={handleLocationSubmit} autoFocus />
        </div>
    );

    const emailPassword360Footer = (
        <div>
            <Button className='view-button' label="Submit" icon="pi pi-check" loading={submitLoading} onClick={handleTeamUpdateSubmit} autoFocus />
        </div>
    );

    const header = renderHeader();

    return (
        <div className="card">
            <Toast ref={toast} />
            <DataTable className="oba-datatable" value={customers} paginator rows={10} rowsPerPageOptions={[5, 10, 50, 100]} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" scrollable scrollHeight="65vh" header={header} filters={filters} loading={loading} onFilter={(e) => setFilters(e.filters)}
                dataKey="team_id"
                stateStorage="session" stateKey="dt-state-demo-local" emptyMessage="No Teams found." tableStyle={{ minWidth: '50rem' }}>
                <Column field="name" header="Team" frozen sortable style={{ minWidth: 180 }} body={(rowData, options) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '11px', color: '#7a7a84', flexShrink: 0 }}>#{options.rowIndex + 1}</span>
                        {rowData.name}
                    </div>
                )}></Column>
                <Column field="location_count" header="Locations" sortable style={{ minWidth: '2rem' }}></Column>
                <Column header="Manage Locations" body={manageLocationView} style={{ minWidth: '2rem' }}></Column>
                <Column header="Update 360 Email/Password/CC Email" body={update360EmailPassword} style={{ minWidth: '11rem' }}></Column>
                <Column body={deleteBody} style={{ width: '10%' }}></Column>
            </DataTable>

            <AppModal header="Manage Allowed Locations" visible={locationVisible} panelStyle={{ width: '50vw' }} onHide={handleLocationOnHide} footer={locationManageFooter}>
                <div>
                    <div className='purchase-form-group'>
                        <div className="card flex justify-content-center">
                            <MultiSelect value={allowedLocations} onChange={(e) => setAllowedLocations(e.value)} options={activeLocations} optionLabel="name"
                                filter placeholder="Manage Locations" maxSelectedLabels={3} className="w-full md:w-20rem language-multiselect" />
                        </div>
                    </div>
                </div>
            </AppModal>

            <AppModal
                header="Update Office 360 Email and Password / CC Email"
                visible={emailPassword360Visible}
                panelStyle={{ width: '50vw' }}
                onHide={handleEmailPassword360OnHide}
                footer={emailPassword360Footer}
            >
                <div>
                    <FlexComponent gap="1rem" className='profileContainer'>

                        <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                            <label htmlFor="email360">Office 360 Email </label>
                            <span className="p-input-icon-right full-input">
                                <InputText
                                    value={email360}
                                    className='full-input'
                                    id="email360"
                                    onChange={(e) => setEmail360(e.target.value)}
                                />
                            </span>
                        </div>
                        <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                            <label htmlFor="password">Office 360 Password </label>
                            <span className="p-input-icon-right full-input">
                                <i className={`pi ${password360Visible ? 'pi-eye' : 'pi-eye-slash'} password-icon`} onClick={handlePassword360Visible} />
                                <InputText
                                    value={password360}
                                    type={`${password360Visible ? 'text' : 'password'}`}
                                    className='full-input'
                                    id="password"
                                    aria-describedby="password-help"
                                    onChange={(e) => setPassword360(e.target.value)}
                                />
                            </span>
                        </div>
                    </FlexComponent>
                    <div className="flex flex-column gap-2 lable-input-group inputContainerDiv" style={{ width: '50%' }}>
                        <label htmlFor="ccEmail">CC Email </label>
                        <span className="p-input-icon-right full-input">
                            <InputText
                                value={ccEmail}
                                className='full-input'
                                id="ccEmail"
                                onChange={(e) => setCcEmail(e.target.value)}
                            />
                        </span>
                    </div>
                </div>
            </AppModal>
        </div>
    );
}